import { getTourPackageDetail } from "@/src/actions/tour/tourAction";
import PackageDetail from "@/src/components/Tour/PackageDetail";
import { searchResult } from "@/src/components/Tour/staticDatas/apiReplicateData";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSEO } from "../../hooks/useSEO";

export default function PackageDetailPage() {
  const packageDetailId = useParams().packageId;
  const [packageDetail, setPackageDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { setSEO } = useSEO();

  useEffect(() => {
    // Fetch package details using packageDetailId if needed
    console.log("Package Detail ID:", packageDetailId);
  }, [packageDetailId]);


  useEffect(() => {
    setIsLoading(true);
    setSEO("Loading Package... | Yatra Tickets");
    getTourPackageDetail(packageDetailId, (data) => {
      if (data && data.Package) {
        setPackageDetail(data);
        const title = data.Package.Title || "Package Detail";
        const desc = data.Package.Summary || data.Destination?.Description || "";
        const img = data.Destination?.ImageUrl || (data.Files && data.Files[0]?.FileURL) || "";
        
        setSEO(`${title} | Yatra Tickets`, desc, img);
      }
      setIsLoading(false);
    });
    // Simulate fetching package detail based on packageDetailId
  }, [packageDetailId, setSEO]);


  return packageDetail ? <PackageDetail pkg={packageDetail} /> : isLoading ? <div>Loading...</div> : <div>No package details found.</div>;
}
